export default ({ copiedShield, copiedSection, copiedSections, selectedShield, textTypingResource }) => {
  if (!!textTypingResource) {
    return false;
  } else if (!!copiedShield) {
    return !!selectedShield;
  } else if (!!selectedShield && !!copiedSection) {
    return true;
  } else if (!!selectedShield && !!copiedSections.length) {
    return true;
  }
  return false;
};
